import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import { getPedidosAdmin } from '../actions'
import AdminMenu from '../components/admin_menu'
require("moment/locale/es");

class AdminPedidos extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false,
          stats:["PENDIENTE","EN PROCESO","TERMINADO", "ENTREGADO"]
    	}
      this.verPedido=this.verPedido.bind(this)
    moment.locale('es')
    }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    this.props.getPedidosAdmin(1)
  }

  componentDidUpdate(prevProps, prevState){

  }

  verPedido(pos){
     this.props.history.push("/admin/pedido/"+this.props.pedidos.pedidos[pos].id)
  }

	render() {  

		/*if(this.state.loading){
			return <div>CARGANDO</div>
		}*/
    var total=0

    const  pedidos = this.props.pedidos.pedidos.map((pedido,i)=>{
      return (
        <tr key={i}>
          <td>{ moment.unix(pedido.fechaunix).format('DD.MM.YYYY HH:mm') }</td>
          <td dangerouslySetInnerHTML={{__html:pedido.cuerpo}}></td>
          <td>${(parseFloat(pedido.monto)+parseFloat(pedido.iva)).toFixed(2)}</td>
          <td>{this.state.stats[pedido.stat]}</td>
          <td><button type="button" className="btn btn-info" onClick={(e) => this.verPedido(i)}>VER</button></td>
        </tr>
      )
    })

    return (
      <div className="container">
      <section className="row mb-5 sombraHead mt-3 clearfix" >
        <div className="col-md-3 mb-3">
        <AdminMenu />
        </div>

        <div className="col-md-9 mb-3">
          <div>
            <h1 className="display-4">Pedidos</h1>
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">FECHA</th>
                <th scope="col">DETALLE</th>
                <th scope="col">MONTO</th>
                <th scope="col">ESTADO</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              { pedidos }
            </tbody>
          </table>
          
        </div>

      </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
	return {
    	pedidos: state.pedidos,
      usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    getPedidosAdmin: (pag) => {
      dispatch(getPedidosAdmin(pag))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPedidos)




// WEBPACK FOOTER //
// ./src/containers/admin_pedidos.js